import React from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../store';
import * as propertySelectors from '../modules/property/selectors';
import NotFoundTemplate from '../screens/others/NotFound';
import { isContractorOnly } from '../modules/invitation';

interface Props {
  children: React.ReactNode;
}

export const ContractorElectricGuard: React.FC<Props> = ({ children }) => {
  const property = useSelector((state: AppState) => propertySelectors.getProperty(state));
  const propertyStatus = useSelector((state: AppState) => state.property.status);

  if (propertyStatus === 'set' && isContractorOnly(property.applicantType) && property.hasElectricContract === false) {
    return <NotFoundTemplate />;
  }

  return <>{children}</>;
};
